<div class="main-content">
  <div class="container-fluid">
      <div class="row">
          <div class="col-md-8">
              <div class="card">
                  <div class="card-header card-header-squirrel">
                      <h4 class="card-title">{{this.translate.data['CREATEDEMOUSER'] | translate}}</h4>
                  </div>
                  <div class="card-body">
                      <!-- <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached" >
                          <mat-spinner></mat-spinner>
                          <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                            Squirrel's API rate limit has been reached. It will be reset in one minute.
                          </div>
                      </div> -->
                      <form [formGroup]="demoUserProfileForm" novalidate>
                          <div class="row">
                              <div class="col-md-6">
                                      <mat-form-field class="example-full-width">
                                          <input matInput  placeholder="{{this.translate.data['EMAIL'] | translate}}" formControlName="email">
                                      </mat-form-field>
                              </div>
                              <div class="col-md-6">
                                <mat-form-field class="example-full-width">
                                    <input matInput placeholder="{{this.translate.data['COMPANYNAME'] | translate}}"  formControlName="companyName">
                                </mat-form-field>
                            </div>
                        </div>
                          <div class="row">
                              <div class="col-md-6">
                                  <mat-form-field class="example-full-width">
                                      <input matInput  placeholder="{{this.translate.data['FULLNAME'] | translate}}" formControlName="fullName">
                                  </mat-form-field>
                              </div>
                              <div class="col-md-6">
                                  <mat-form-field class="example-full-width">
                                      <input matInput placeholder="{{this.translate.data['PHONENUMBER'] | translate}}" formControlName="phoneNumber">
                                  </mat-form-field>
                              </div>
                          </div>
                          <div class="row">
                            <div class="col-md-8">
                              <section class="example-full-width">
                                  <mat-slide-toggle color="primary"  formControlName="construction" labelPosition="after">
                                      <!-- {{this.translate.data['PHONENUMBERCONFIRMED'] | translate}} -->
                                      Hochbau Projekt
                                  </mat-slide-toggle>
                              </section>                        
                          </div>
                          <div class="col-md-8">
                            <section class="example-full-width">
                                <mat-slide-toggle color="primary"  formControlName="infrastructure" labelPosition="after">
                                    <!-- {{this.translate.data['PHONENUMBERCONFIRMED'] | translate}} -->
                                    Infrastruktur Projekt
                                </mat-slide-toggle>
                            </section>                        
                        </div>
                    </div>
    
                          <!-- <div class="row">
                              <div class="col-md-4">
                                  <mat-form-field class="example-full-width">
                                      <input matInput placeholder="{{this.translate.data['STREETADDRESS'] | translate}}"  formControlName="streetAddress">
                                  </mat-form-field>
                              </div>
                              <div class="col-md-2">
                                  <mat-form-field class="example-full-width">
                                      <input matInput  placeholder="{{this.translate.data['POSTALCODE'] | translate}}" formControlName="postalCode">
                                  </mat-form-field>
                              </div>
                              <div class="col-md-6">
                                  <mat-form-field class="example-full-width">
                                      <input matInput  placeholder="{{this.translate.data['LOCALITY'] | translate}}" formControlName="locality">
                                  </mat-form-field>
                              </div>
                              <div class="col-md-4">
                                  <mat-form-field class="example-full-width">
                                      <input matInput  placeholder="{{this.translate.data['COUNTRY'] | translate}}" formControlName="country">
                                  </mat-form-field>
                              </div>
                              <div class="col-md-2">
                                  <mat-form-field class="example-full-width">
                                      <input matInput  placeholder="{{this.translate.data['REGION'] | translate}}" formControlName="region">
                                  </mat-form-field>
                              </div>
                              <div class="col-md-6">
                                  <mat-form-field class="example-full-width">
                                      <input matInput  placeholder="{{this.translate.data['WEBSITE'] | translate}}" formControlName="webSite">
                                  </mat-form-field>
                              </div>
                          </div> -->
                          <button mat-raised-button type="submit" class="btn btn-squirrel pull-right" (click)="createDemouser()">{{this.translate.data['CREATEDEMOUSER'] | translate}}</button>
                          <div class="clearfix"></div>
                      </form>
                  </div>
              </div>
          </div>
          <!-- <div class="col-md-4">
              <div class="card card-profile">
                  <div class="card-avatar">
                      <a href="javascript:void(0)">
                          <img class="img" src="{{avatar}}" />
                      </a>
                  </div>
                  <div class="card-body">
                      <h4 class="card-title">{{userProfile.username}}</h4>
                      <p class="card-description">
                      </p>
                  </div>
              </div>
          </div> -->
      </div>
  </div>
</div>
